import * as React from 'react';

import AdditionalFilter from 'af-components/Table/Filters/AdditionalFilter/Multiselect';

import type { JobFilterItem } from '../JobFilterItem';
import styles from './styles.module.scss';
import { ReportTypeViewTableAdditionalFilterType, type ReportTypeViewTableAdditionalFilter, type ReportTypeViewTableAdditionalJobFilter } from '../types';

type Props = {
	filter: ReportTypeViewTableAdditionalJobFilter;
	editFilter: (id: string | number, newValue: ReportTypeViewTableAdditionalFilter) => void;
	removeFilter: (id: string | number) => void;
	jobOptions: JobFilterItem[];
	lazyLoadJobs: (loaded: boolean) => Promise<void>;
	initiallyOpened: boolean;
};

const JobFilter: React.FC<Props> = (props) => {
	const { editFilter, filter, removeFilter, jobOptions, lazyLoadJobs, initiallyOpened } = props;

	const selected = React.useMemo(() => {
		if (!filter.value === null) {
			return [];
		}
		return filter.value?.length ? jobOptions.filter((_option) => filter.value?.includes(_option.id)) : [];
	}, [filter.value, jobOptions]);

	const onClear = React.useCallback(() => {
		removeFilter(filter.id);
	}, [filter.id, removeFilter]);

	const onChange = React.useCallback((newOptions: JobFilterItem[]) => {
		editFilter(filter.id, {
			type: ReportTypeViewTableAdditionalFilterType.JOB,
			value: newOptions.map((_option) => _option.id),
			id: filter.id,
		});
	}, [editFilter, filter.id]);

	const renderJobOption = React.useCallback((option: JobFilterItem) => {
		return (
			<div className={styles['job-option']}>
				<div className={styles['job-option__label']}>
					{option.jobCode} | {option.title}
				</div>
				<div className={styles['job-option-subtitle']}>
					{
						option.isInternal
							? <div className={styles['job-option__internal-indicator']}>I</div>
							: null
					}
					{option.customerCompany}
				</div>
			</div>
		);
	}, []);

	React.useEffect(() => {
		if (!jobOptions.length) {
			lazyLoadJobs(false);
		}
	}, [jobOptions.length, lazyLoadJobs]);

	return (
		<AdditionalFilter
			autoOpen={initiallyOpened}
			filterName="Job"
			forBulkModal={false}
			onChange={onChange}
			onLazyLoad={lazyLoadJobs}
			onRemoveFilter={onClear}
			options={jobOptions}
			renderOptionOverride={renderJobOption}
			selected={selected}
		/>
	);
};

export default React.memo(JobFilter);
